import { Dropdown } from 'react-bootstrap';
import styled from 'styled-components';

import { colorScheme } from '../../theme';

export const DropdownWrapper = styled(Dropdown)`
  .dropdown-item {
    cursor: pointer;
  }
`;

export const SelectDropdownWrapper = styled(Dropdown)`
  .dropdown-item {
    cursor: pointer;
  }

  .dropdown-toggle {
    background-color: ${colorScheme.input.background};
    border: 1px solid ${colorScheme.input.border};
    color: ${colorScheme.text.base};
    min-width: 180px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &::after {
      margin-left: 0.5rem;
    }

    &:hover,
    &:focus {
      background-color: ${colorScheme.input.background};
      border-color: ${colorScheme.focus};
      color: ${colorScheme.text.base};
    }
  }
`;

export const DropdownLabel = styled('strong')`
  display: block;
  width: 100%;
  padding: 0.25rem 0.75rem;
  clear: both;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
`;

export const DropdownMenu = styled(Dropdown.Menu)<{ maxHeight?: string }>`
  min-width: 17rem;
  max-height: ${({ maxHeight }) => maxHeight || '90vh'};
  overflow: auto;
`;

export const DropdownInputWrapper = styled('div')`
  padding: 0.25rem 0.75rem;
`;
